export const getUniqueNumber = (() => {
    let uniqueNumber = 0;
    return () => uniqueNumber++;
})();

export const commaSeparateNumber = (value: number | string, maxDecimals = 2): string => {
    const number = +value;
    if ([Infinity, -Infinity, NaN].includes(number)) return "0";
    const parts = `${value}`.split(".");
    if (maxDecimals && parts.length === 2) {
        const [integer, decimal] = parts;
        const rounded = `${round(+`0.${decimal}`, maxDecimals)}`;
        const units = +integer + parseInt(rounded);
        const decimals = decimal.length > maxDecimals ? rounded.slice(2) : decimal;

        return units > +integer ? units.toLocaleString() : units.toLocaleString() + "." + decimals;
    }
    return round(number).toLocaleString();
};

export const round = (number: number, maxDecimals = 0): number => {
    const pow = Math.pow(10, maxDecimals);
    const value = Math.round(+number * pow) / pow;
    if ([Infinity, -Infinity, NaN].includes(value)) return 0;
    return value;
};

export const formatClientName = (clientName: string) => {
    if (!clientName.includes(",")) {
        return clientName;
    } else {
        const clientNamesArr = clientName.split(",").map((name) => name.trim());
        let formattedNameStr = "";
        if (clientNamesArr.length === 2) {
            formattedNameStr = `${clientNamesArr[0]} and ${clientNamesArr[1]}`;
        } else {
            for (let i = 0; i < clientNamesArr.length; i++) {
                if (i < clientNamesArr.length - 2) {
                    formattedNameStr += `${clientNamesArr[i]}, `;
                } else if (i === clientNamesArr.length - 2) {
                    formattedNameStr += `${clientNamesArr[i]}, and `;
                } else {
                    formattedNameStr += `${clientNamesArr[i]}`;
                }
            }
        }
        return formattedNameStr;
    }
};

export const formatPhoneNumber = (phoneNumber: number | undefined) => {
    if (!phoneNumber) return null;
    var match = String(phoneNumber).match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
        return `${match[1]}-${match[2]}-${match[3]}`;
    }
    return null;
};

export const getLicenseLabel = (license: { type: "license" | "nmls"; number: string } | null | undefined) => {
    if (!license || !license.number) return "";
    return `${license.type === "nmls" ? "NMLS#" : "License#"} ${license.number}`;
};

export const truncateString = (
    str: string,
    maxLength: number,
    preserveWord?: boolean,
    preserveLeft?: boolean,
): string => {
    if (str.length <= maxLength) {
        return str;
    }
    const truncatedStr = str.slice(0, maxLength);
    const lastSpaceIndex = truncatedStr.lastIndexOf(" ");
    const nextSpaceIndex = str.indexOf(" ", maxLength);
    if (!preserveWord || (lastSpaceIndex === -1 && nextSpaceIndex === -1)) {
        return truncatedStr + "...";
    }
    if (
        preserveLeft ||
        nextSpaceIndex === -1 ||
        (lastSpaceIndex !== -1 && maxLength - lastSpaceIndex < nextSpaceIndex - maxLength)
    ) {
        return truncatedStr.slice(0, lastSpaceIndex) + "...";
    }
    return str.slice(0, nextSpaceIndex) + "...";
};

export const getListReportsUrl = (path?: string): string => {
    if (typeof window === "undefined") {
        return path ? `https://www.listreports.com${path}` : "https://www.listreports.com";
    }

    const isStageEnvironment =
        window.location.origin.includes("localhost") ||
        window.location.origin.includes("stage.") ||
        window.location.origin.includes("test.");
    const baseUrl = isStageEnvironment ? "https://stage.listreports.com" : "https://www.listreports.com";
    return path ? `${baseUrl}${path}` : baseUrl;
};

export const commaSeparateInt = (number: number): string => {
    return commaSeparateNumber(number, 0);
};

export const dollar = (number: number, maxDecimals = 0): string => {
    if (isNaN(number)) return "N/A";
    const roundedNumber = round(number, maxDecimals);
    const dollarSign =
        roundedNumber < 0 && roundedNumber !== -Infinity && roundedNumber !== Infinity ? "-$" : "$";
    return `${dollarSign}${commaSeparateNumber(Math.abs(number), maxDecimals)}`;
};
